<template>
  <div>
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        @click="navigatorTo(item.url)"
        :class="[
          item.url.includes(defaultItem) ? 'active' : '',
          !index ? 'item-header' : 'item',
        ]"
      >
        {{ TLang(item.title, "user") }}
      </li>
    </ul>
  </div>
</template>

<script>
import { getQueryString } from "@utils";
import { doValidate } from "@fetch/index";
const cityId = getQueryString("city") || 145;
export default {
  name: "UserLeft",
  props: {
    defaultItem: {
      type: String,
      default: "/shop/order/list",
    },
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    doValidate().then((res) => {
      if (res.code === 200) {
        if (res.data) {
           this.list = [
            {
              title: "个人中心",
              url: "",
            },
            {
              title: "我的福利",
              url: `/user/center/card?city=${cityId}`,
            },
            {
              title: "我的优惠券",
              url: `/user/center/usercoupon?city=${cityId}`,
            },
            {
              title: "我的订单",
              url: `/unitedorder/?city=${cityId}`,
              // url: `/user/center/order/movie?city=${cityId}`,
            },
            // {
            //   title: "健康订单",
            //   url: `/health/orderList?city=${cityId}`,
            // },
            {
              title: "我的健康权益",
              url: `/health/rights?city=${cityId}`,
            },
            {
              title: "兑换票师傅卡券",
              url: `/user/center/exchangeCard?city=${cityId}`,
            },
            {
              title: "个人信息",
              url: `/user/center/userInfo?city=${cityId}`,
            },
            {
              title: "收货地址",
              url: `/shop/user/address?city=${cityId}`,
            },
            {
              title: "账户绑定",
              url: `/user/center/bind?city=${cityId}`,
            },
            {
              title: "修改密码",
              url: `/user/center/password?city=${cityId}`,
            },
            {
              title: "修改支付密码",
              url: `/user/center/paypassword/modify?city=${cityId}`,
            },
          ];
        } else {
          this.list = [
            {
              title: "个人中心",
              url: "",
            },
            {
              title: "我的福利",
              url: `/user/center/card?city=${cityId}`,
            },
            {
              title: "我的优惠券",
              url: `/user/center/usercoupon?city=${cityId}`,
            },
            {
              title: "电影订单",
              url: `/newmovie/orders?city=${cityId}`,
              // url: `/user/center/order/movie?city=${cityId}`,
            },
            {
              title: "购物订单",
              url: "/shop/order/list",
            },
            {
              title: "电子券订单",
              url: `/user/center/order/codegoods?city=${cityId}`,
            },
            {
              title: "玩乐订单",
              url: `/user/center/order/activity?city=${cityId}`,
            },
            {
              title: "旅游景点订单",
              url: `/user/center/order/scenery?city=${cityId}`,
            },
            {
              title: "演出订单",
              url: `/drama_pc/order/list?city=${cityId}`,
            },
            {
              title: "健身订单",
              url: `/user/center/order/fitness?city=${cityId}`,
            },
            {
              title: "体检订单",
              url: `/health/orderList?city=${cityId}`,
            },
            {
              title: "我的问诊单",
              url: `/health/OnlineOrderList?city=${cityId}`,
            },
            {
              title: "兑换票师傅卡券",
              url: `/user/center/exchangeCard?city=${cityId}`,
            },
            {
              title: "个人信息",
              url: `/user/center/userInfo?city=${cityId}`,
            },
            {
              title: "收货地址",
              url: `/shop/user/address?city=${cityId}`,
            },
            {
              title: "账户绑定",
              url: `/user/center/bind?city=${cityId}`,
            },
            {
              title: "修改密码",
              url: `/user/center/password?city=${cityId}`,
            },
            {
              title: "修改支付密码",
              url: `/user/center/paypassword/modify?city=${cityId}`,
            },
          ];
        }
      }
    });
  },
  methods: {
    navigatorTo(href) {
      href
        ? (window.location.href = window.location.origin + href)
        : window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.item-header {
  width: 200px;
  padding: 0 16px;
  height: 60px;
  line-height: 60px;
  border-bottom: solid 1px #fff;
  background-color: #1a4a9e;
  box-sizing: border-box;
  color: #fff;
  font-size: 16px;
}

.item {
  width: 200px;
  padding: 0 16px;
  height: 60px;
  line-height: 60px;
  border-bottom: solid 1px #fff;
  box-sizing: border-box;
  background-color: #619ee0;
  color: #fff;
  font-size: 16px;

  &:hover {
    color: #619ee0;
    border-left: 4px solid #619ee0;
    background: #fff;
    text-decoration: none;
    cursor: pointer;
  }
}
.item.active {
  color: #1a4a9e;
  border-left: 4px solid #1a4a9e;
  background: #fff;
  text-decoration: none;
}
</style>
